export default ({size = 'lg', color = '', className = ''}) => (
  <div className={`flex justify-center ${className}`}>
    <span className={`loading loading-spinner loading-${size} ${color ? `text-${color}` : ''}`}></span>
  </div>
)